import classNames from 'classnames'
import React from 'react'
import style from './styles/tag.module.scss'

interface IProps {
  age: string | null
  theme?: string
  size?: string
  className?: string
}

const AgeTag = ({
  age = '',
  theme = 'gray',
  size = 'medium',
  className = ''
}: IProps): React.ReactElement => {
  let correctAge = ''
  if (age !== null) {
    if (age.includes('лет')) {
      correctAge = age
    } else {
      correctAge = `${age} лет`
    }
  }
  if (age !== null) {
    return (
      <span
        className={classNames({
          [style.tag]: true,
          [style[`theme_${theme}`]]: Boolean(theme),
          [style[`size_${size}`]]: Boolean(size),
          [className]: Boolean(className)
        })}
      >
        {correctAge}
      </span>
    )
  }
  return <></>
}

export default AgeTag
